import { createFileRoute } from "@tanstack/react-router";
import VisitBuildingSettings from "@/components/building_admin/building_admin_settings/visit";
import { allEntrancesOptions, buildingOptions } from "@/api";
import { SettingsSubPage } from "@/components/building_admin/building_admin_settings/SettingsSubPage";
import { useRouterStore } from "@/store/zustandStore";
import { useBuildingWelcomeVisitAccess } from "@/hooks/useBuildingWelcomeVisitAccess";

const PageComponent = () => {
  const hasWelcomeVisit = useBuildingWelcomeVisitAccess(true);
  const card = {
    icon: "group",
    value: "visit",
    label: "Welcome Visit",
    enabled: hasWelcomeVisit,
    to: "/building/settings/visit",
    descriptionKey: "PAGES.BUILDING_SETTINGS.MODULE_DESCRIPTIONS.VISIT",
  };
  return (
    <SettingsSubPage
      cardOptions={card}
      PageComponent={VisitBuildingSettings}
      label="Visit"
      path="/building/settings/visit"
      allowReceptionistAccess
    />
  );
};

export const Route = createFileRoute("/_portal/building/settings/visit")({
  component: PageComponent,
  loader: () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(allEntrancesOptions);
    queryClient.ensureQueryData(buildingOptions);
  },
});
